import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import { z } from "zod";
import {
  HeaderRoot,
  HeaderButton,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { OneLivAdditionalInfoForm } from "@/components/oneliv/oneliv-additional-info-form";

import type { JSX } from "react";

const GetOneLivUserAdditionalInfo = graphql(`
  query GetOneLivUserAdditionalInfo {
    locus_membro {
      ...OneLivAdditionalInfoFormFragment
    }
  }
`);

const oneLivAdditionalInfoPageSearchSchema = z.object({
  action: z.string().optional().catch(""),
});

const OneLivAdditionalInfo = (): JSX.Element => {
  const query = useGraphQL(GetOneLivUserAdditionalInfo);

  const { data } = query;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Informações adicionais" align="center" />
      </HeaderRoot>

      <Page>
        <AsyncDataWrapper {...query}>
          {data ? <OneLivAdditionalInfoForm data={data.locus_membro} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/oneliv/additional-info")({
  component: OneLivAdditionalInfo,
  validateSearch: oneLivAdditionalInfoPageSearchSchema,
});
